// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3549) return "static/chunks/3549.77e6be4dcb8c777e.js";
	if (chunkId === 1901) return "static/chunks/1901.da7eaf20e5ff22fe.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"672":"8e1c39a99f00357e","1204":"55add010868509dd","2278":"c15a27b0457c4f01","5820":"45b1611fc6437904","8696":"39433153851605b7","9109":"3d600d334122887b","9823":"0f7834c98acb4281"}[chunkId] + ".js";
};